/* eslint-disable global-require */
import angular from 'angular';

import './platform-forms.style.scss';
import { OnlinePlatformsFormController } from './platform-forms.controller';

export const FormOnlinePlatforms = {
  selector: 'formOnlinePlatforms',
  controller: OnlinePlatformsFormController,
  bindings: {
    exit: '&',
    show: '=',
    vehicle: '<',
  },
  template: /* html */ `
    <form class="default-form backdrop-overlay-form online-platforms-form" ng-submit="formTransmission()" ng-if="$ctrl.show">
      <div class="row">
        <div class="col-md-3">
          <div class="box-wrap">
            <div class="boxL">
              <vehicle-data-check [vehicle]="$ctrl.vehicle"></vehicle-data-check>
            </div>
          </div>
        </div>

        <div class="col-md-9">

          <div class="box-wrap">
            <div class="boxL">
              <h3>
                mobile.de
              
                <tag color="green" text="Synchronisiert" ng-if="$ctrl.vehicle.apiData.MOBILE_SELLER"></tag>
                <tag color="red" text="Nicht Synchronisiert" ng-if="!$ctrl.vehicle.apiData.MOBILE_SELLER"></tag>
              </h3>

              <ng-container ng-if="$ctrl.mobileSellerConfig && $ctrl.vehicle.apiData.MOBILE_SELLER">
                <div class="statistics row">
                  <div class="data-point col-md-3 col-sm-6 px-0">
                    <span>Veröffentlichung</span>
                    <span>{{ $ctrl.vehicle.apiData.MOBILE_SELLER.details.statistics.creationDate | date }} ({{ $ctrl.vehicle.apiData.MOBILE_SELLER.details.statistics.creationDate | daysSince }} Tage)</span>
                  </div>
                  <div class="data-point col-md-3 col-sm-6 px-0" ng-if="$ctrl.vehicle.apiData.MOBILE_SELLER.details.statistics.modificationDate">
                    <span>Letztes Update</span>
                    <span>{{ $ctrl.vehicle.apiData.MOBILE_SELLER.details.statistics.modificationDate | date }}</span>
                  </div>
                  <div class="data-point col-md-3 col-sm-6 px-0" ng-if="$ctrl.vehicle.apiData.MOBILE_SELLER.details.statistics.impressions">
                    <span>Impressionen</span>
                    <span>{{ $ctrl.vehicle.apiData.MOBILE_SELLER.details.statistics.impressions }}</span>
                  </div>
                  <div class="data-point col-md-3 col-sm-6 px-0" ng-if="$ctrl.vehicle.apiData.MOBILE_SELLER.details.statistics.parkings">
                    <span>Geparkt</span>
                    <span>{{ $ctrl.vehicle.apiData.MOBILE_SELLER.details.statistics.parkings }}</span>
                  </div>
                  <div class="data-point col-md-3 col-sm-6 px-0" ng-if="$ctrl.vehicle.apiData.MOBILE_SELLER.details.statistics.emails">
                    <span>E-Mails</span>
                    <span>{{ $ctrl.vehicle.apiData.MOBILE_SELLER.details.statistics.emails }}</span>
                  </div>
                  <div class="data-point col-md-3 col-sm-6 px-0" ng-if="$ctrl.vehicle.apiData.MOBILE_SELLER.details.statistics.calls">
                    <span>Anrufe</span>
                    <span>{{ $ctrl.vehicle.apiData.MOBILE_SELLER.details.statistics.calls }}</span>
                  </div>
                </div>

                <div class="btn-wrap right">
                  <a href="{{ $ctrl.vehicle.apiData.MOBILE_SELLER.details.url }}" class="btn-lvl3" target="_blank"><i class="fal fa-external-link-square"></i> Zur Anzeige</a>
                  <button type="button" ng-click="$ctrl.deleteMobileAd(true)" class="btn-lvl1" ng-class="{'btn-sending': $ctrl.formData.sending}" ng-disabled="$ctrl.formData.sending">Anzeige löschen</button>
                </div>

                <div class="divider"></div>

                <div class="subtitle">
                  <span class="title-md">Beschreibung der Anzeige</span>
                </div>

                <div class="row">
                  <div class="input-wrap col-md-12">
                    <input type="text" ng-model="$ctrl.formData.title" placeholder="Titel des Inserats" required>
                    <label>Titel des Inserats</label>
                  </div>
                </div>

                <div class="row">
                  <div class="col input-wrap" ng-if="$ctrl.formData.mobileSellerDescription">
                    <rich-text-editor
                      ng-if="$ctrl.formData.showDescription"
                      custom-model="$ctrl.formData.mobileSellerDescription.formatted"
                      custom-model-raw="$ctrl.formData.mobileSellerDescription.raw"
                      placeholder=""
                    ></rich-text-editor>
                  </div>
                </div>

                <div class="btn-wrap">
                  <button type="button" class="btn-lvl3" ng-click="$ctrl.addModelDescription()"><i class="fa-solid fa-block-quote"></i> Technische Ausstattung</button>
                  <button type="button" class="btn-lvl3" ng-click="$ctrl.addSeriesOptions()"><i class="fa-solid fa-block-quote"></i> Serienoptionen (Hersteller)</button>
                  <button type="button" class="btn-lvl3" ng-click="$ctrl.addAdditionalOptions()"><i class="fa-solid fa-block-quote"></i> Aufpreisoptionen (Hersteller)</button>
                </div>

                <div class="divider"></div>

                <div class="subtitle">
                  <span class="title-md">Highlights</span>
                </div>

                <div class="row" ng-repeat="highlight in $ctrl.formData.highlights track by $index">
                  <div class="input-wrap col-md-8">
                    <input type="text" ng-model="$ctrl.formData.highlights[$index]" placeholder="Highlight (22 Zeichen)" maxlength="22">
                    <label>Highlight (22 Zeichen)</label>
                  </div>

                  <div class="btn-wrap col-md-4">
                    <button type="button" class="btn-lvl3" ng-click="$ctrl.removeHightlight($index)"><svg class="ab-icon"><use xlink:href="#btn-times"></use></svg></button>
                  </div>
                </div>

                <div class="btn-wrap">
                  <button type="button" class="btn-lvl3" ng-click="$ctrl.addHighlight()">
                    <svg class="ab-icon"><use xlink:href="#btn-add"></use></svg> Highlight hinzufügen
                  </button>
                </div>

                <div class="divider"></div>

                <div class="subtitle">
                  <span class="title-md">Fahrzeugdaten</span>
                </div>

                <div class="row input-group checkbox-wrap">
                  <div class="col-md-6 input-wrap" data-prefix="€">
                    <input ng-model="$ctrl.formData.onlinePrice" type="text" placeholder="Online Preis" required />
                    <label>Online Preis</label>
                  </div>

                  <div class="checkbox col-lg-6">
                    <input type="checkbox" ng-model="$ctrl.formData.warranty" id="warranty">
                    <label for="warranty">Fahrzeug hat Garantie</label> 
                  </div>
                </div>

                <div class="row checkbox-wrap">
                  <div class="col-md-6 input-wrap">
                    <input ng-model="$ctrl.formData.internalNumber" type="text" placeholder="Interne Nummer (optional)" />
                    <label>Interne Nummer (optional)</label>
                  </div>

                  <div class="checkbox col-lg-6">
                    <input type="checkbox" ng-model="$ctrl.formData.dealersOnly" id="dealersOnly">
                    <label for="dealersOnly">Nur für andere Händler sichtbar</label> 
                  </div>
                </div>

                <div class="divider"></div>

                <div class="subtitle">
                  <span class="title-md">Angaben zur Verfügbarkeit</span>
                </div>

                <div class="row">
                  <ab-datepicker class="col-md-6 px-0" selected-date="$ctrl.formData.deliveryDate" start-date="$ctrl.formData.deliveryDate" required="false" placeholder="Verfügbar ab (optional)"></ab-datepicker>

                  <div class="input-wrap col-md-6 select">
                    <select ng-model="$ctrl.formData.deliveryPeriod">
                      <option value="">Lieferzeitraum wählen (optional)</option>
                      <option value="1">1 Tag</option>
                      <option value="2">2 Tage</option>
                      <option value="3">3 Tage</option>
                      <option value="5">5 Tage</option>
                      <option value="6">6 Tage</option>
                      <option value="7">7 Tage</option>
                      <option value="14">14 Tage</option>
                      <option value="60">60 Tage</option>
                      <option value="90">90 Tage</option>
                      <option value="120">120 Tage</option>
                      <option value="150">150 Tage</option>
                      <option value="180">180 Tage</option>
                      <option value="270">270 Tage</option>
                      <option value="360">360 Tage</option>
                    </select>
                    <label>Verfügbar in (optional)</label>
                  </div>
                </div>

                <div class="divider"></div>

                <div class="subtitle">
                  <span class="title-md">Veröffentlichung des Inserats</span>
                </div>

                <div class="row input-group checkbox-wrap">
                  <div class="checkbox col-lg-6">
                    <input type="checkbox" ng-model="$ctrl.formData.deactivated" id="deactivated">
                    <label for="deactivated">Inserat deaktivieren</label> 
                  </div>
                </div>

                <div class="btn-wrap right">
                  <button type="button" ng-click="$ctrl.updateMobileAd()" class="btn-lvl1" ng-class="{'btn-sending': $ctrl.formData.sending}" ng-disabled="$ctrl.formData.sending">Anzeige aktualisieren</button>
                </div>
              </ng-container>

              <!-- Add new ad -->

              <ng-container ng-if="$ctrl.mobileSellerConfig && !$ctrl.vehicle.apiData.MOBILE_SELLER">
                <div class="subtitle">
                  <span class="title-md">Fahrzeug veröffentlichen</span>
                  <p class="subtitle">Das Fahrzeug wird beim ausgewählten mobile.de Account veröffentlicht. Alle Aktualisierungen an Fahrzeugdaten und -bildern werden ab dem Zeitpunkt der Veröffentlichung in Echtzeit mit mobile.de synchronisiert.</p>
                </div>

                <div class="subtitle">
                  <span class="title-md">Beschreibung der Anzeige</span>
                </div>

                <div class="row">
                  <div class="input-wrap col-md-12">
                    <input type="text" ng-model="$ctrl.formData.title" placeholder="Titel des Inserats" required>
                    <label>Titel des Inserats</label>
                  </div>
                </div>

                <div class="row">
                  <div class="col input-wrap" ng-if="$ctrl.formData.mobileSellerDescription">
                    <rich-text-editor
                      ng-if="$ctrl.formData.showDescription"
                      custom-model="$ctrl.formData.mobileSellerDescription.formatted"
                      custom-model-raw="$ctrl.formData.mobileSellerDescription.raw"
                      placeholder="Hier kannst du eine Beschreibung für das Inserat hinzufügen"
                    ></rich-text-editor>
                  </div>
                </div>

                <div class="btn-wrap">
                  <button type="button" class="btn-lvl3" ng-click="$ctrl.addModelDescription()"><i class="fa-solid fa-block-quote"></i> Technische Ausstattung</button>
                  <button type="button" class="btn-lvl3" ng-click="$ctrl.addSeriesOptions()"><i class="fa-solid fa-block-quote"></i> Serienoptionen (Hersteller)</button>
                  <button type="button" class="btn-lvl3" ng-click="$ctrl.addAdditionalOptions()"><i class="fa-solid fa-block-quote"></i> Aufpreisoptionen (Hersteller)</button>
                </div>

                <div class="divider"></div>

                <div class="subtitle">
                  <span class="title-md">Highlights</span>
                </div>

                <div class="row" ng-repeat="highlight in $ctrl.formData.highlights track by $index">
                  <div class="input-wrap col-md-8">
                    <input type="text" ng-model="$ctrl.formData.highlights[$index]" placeholder="Highlight (22 Zeichen)" maxlength="22">
                    <label>Highlight (22 Zeichen)</label>
                  </div>

                  <div class="btn-wrap col-md-4">
                    <button type="button" class="btn-lvl3" ng-click="$ctrl.removeHightlight($index)"><svg class="ab-icon"><use xlink:href="#btn-times"></use></svg></button>
                  </div>
                </div>

                <div class="btn-wrap">
                  <button type="button" class="btn-lvl3" ng-click="$ctrl.addHighlight()">
                    <svg class="ab-icon"><use xlink:href="#btn-add"></use></svg> Highlight hinzufügen
                  </button>
                </div>

                <div class="divider"></div>

                <div class="subtitle">
                  <span class="title-md">Fahrzeugdaten</span>
                </div>

                <div class="row">
                  <div class="col-md-6 input-wrap" data-prefix="€">
                    <input ng-model="$ctrl.formData.onlinePrice" type="text" placeholder="Online Preis" required />
                    <label>Online Preis</label>
                  </div>

                  <ab-select class="px-0 col-md-6" classes="'select input-wrap'" options="$ctrl.mobileSellerAccounts" custom-model="$ctrl.formData.mobileSellerId" placeholder="Mobile.de Account" required="true"></ab-select>
                </div>

                <div class="row">
                  <div class="col-md-6 input-wrap">
                    <input ng-model="$ctrl.formData.internalNumber" type="text" placeholder="Interne Nummer (optional)" />
                    <label>Interne Nummer (optional)</label>
                  </div>
                </div>

                <div class="divider"></div>

                <div class="subtitle">
                  <span class="title-md">Angaben zur Verfügbarkeit</span>
                </div>

                <div class="row">
                  <ab-datepicker class="col-md-6 px-0" selected-date="$ctrl.formData.deliveryDate" start-date="$ctrl.formData.deliveryDate" required="false" placeholder="Verfügbar ab (optional)"></ab-datepicker>

                  <div class="input-wrap col-md-6 select">
                    <select ng-model="$ctrl.formData.deliveryPeriod">
                      <option value="">Lieferzeitraum wählen (optional)</option>
                      <option value="1">1 Tag</option>
                      <option value="2">2 Tage</option>
                      <option value="3">3 Tage</option>
                      <option value="5">5 Tage</option>
                      <option value="6">6 Tage</option>
                      <option value="7">7 Tage</option>
                      <option value="14">14 Tage</option>
                      <option value="60">60 Tage</option>
                      <option value="90">90 Tage</option>
                      <option value="120">120 Tage</option>
                      <option value="150">150 Tage</option>
                      <option value="180">180 Tage</option>
                      <option value="270">270 Tage</option>
                      <option value="360">360 Tage</option>
                    </select>
                    <label>Verfügbar in (optional)</label>
                  </div>
                </div>

                <div class="row input-group checkbox-wrap">
                  <div class="checkbox col-lg-6">
                    <input type="checkbox" ng-model="$ctrl.formData.warranty" id="warranty">
                    <label for="warranty">Fahrzeug hat Garantie</label> 
                  </div>

                  <div class="checkbox col-lg-6">
                    <input type="checkbox" ng-model="$ctrl.formData.dealersOnly" id="dealersOnly">
                    <label for="dealersOnly">Nur für andere Händler sichtbar</label> 
                  </div>
                </div>

                <div class="divider"></div>

                <div class="subtitle">
                  <span class="title-md">Veröffentlichung des Inserats</span>
                </div>

                <div class="row input-group checkbox-wrap">
                  <div class="checkbox col-lg-6">
                    <input type="checkbox" ng-model="$ctrl.formData.deactivated" id="deactivated">
                    <label for="deactivated">Inserat deaktivieren</label> 
                  </div>
                </div>

                <div class="alert-box error" ng-if="$ctrl.errors">
                  <div class="icon-wrap"><svg class="ab-icon"><use xlink:href="#error"></use></svg></div>
                  <div class="text-wrap">
                    <span class="title-md">Fehler beim Veröffentlichen der Anzeige</span>
                    <p>
                      Mobile.de meldet folgende Fehler:
                    </p>
                    <p ng-bind-html="$ctrl.errors"></p>
                  </div>
                </div>

                <div class="btn-wrap right">
                  <button type="button" ng-click="$ctrl.publishMobileAd(true)" class="btn-lvl1" ng-class="{'btn-sending': $ctrl.formData.sending}" ng-disabled="$ctrl.formData.sending">Anzeige veröffentlichen</button>
                </div>
              </ng-container>
            </div>

            <div class="boxL" ng-if="$ctrl.vehicle.apiData.MOBILE_SELLER">
              <div class="intro">
                <h3>Account wechseln</h3>
                <p>Diese Aktion löscht das vorhandene Inserat auf dem aktuellen mobile.de Account und erstellt das identische Inserat auf dem hier ausgewählten Account.</p>
              </div>

              <ng-template ng-if="$ctrl.mobileSellerConfig">
                <div class="row">
                  <ab-select class="px-0 col-md-6" classes="'select input-wrap'" options="$ctrl.mobileSellerAccounts" custom-model="$ctrl.formData.mobileSellerId" placeholder="Mobile.de Account" required="true"></ab-select>
                </div>

                <div class="btn-wrap right">
                  <button type="button" ng-click="$ctrl.switchAccount()" class="btn-lvl1" ng-class="{'btn-sending': $ctrl.formData.sending}" ng-disabled="$ctrl.formData.sending">Account wechseln</button>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>

      

      
    </form>
  `,
};

export default angular.module('directives.formOnlinePlatforms', [])
  .component(FormOnlinePlatforms.selector, FormOnlinePlatforms)
  .name;
